import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import SiteNavDropdownColumn from './SiteNavDropdownColumn';
import { SiteNavDropdownImageModule } from './SiteNavDropdownImageModule';
import classnames from 'classnames';
import styles from './SiteNav-style.scss';

const MAX_NAV_COLUMNS_NO_IMAGE = 5;
const MAX_NAV_COLUMNS_WITH_IMAGE = 3;

const SiteNavFullWidthDropdownContentComponent = ({
    moduleItems,
    trackingLabelPrefix,
    navigationModule,
}) => {
    const { imageUrl } = navigationModule;
    const columns = {};
    let itemCols;
    let imageModule;

    // Group columns by column number - max of 5 column groups allowed
    itemCols = moduleItems
        .reduce((acc, moduleItem) => {
            const { column } = moduleItem;
            // if not already in column object...
            if (!columns[column] || !column) {
                // Keep track of column number and
                columns[column] = true;
                // Store moduleItem in a new array in acc
                acc.push([moduleItem]);
            } else {
                // If already in columns object, add to last array in acc
                acc[acc.length - 1].push(moduleItem);
            }
            return acc;
        }, [])
        .slice(0, MAX_NAV_COLUMNS_NO_IMAGE);

    if (imageUrl) {
        // If there is also an image module - max of 3 column groups allowed
        itemCols = itemCols.slice(0, MAX_NAV_COLUMNS_WITH_IMAGE);
        imageModule = (
            <div className={`${styles.dropdownCol} ${styles.imageModule}`}>
                <SiteNavDropdownImageModule navigationModule={navigationModule} />
            </div>
        );
    }

    const contentClasses = classnames(styles.dropdownContent, styles.isFullWidth);

    return (
        <div className={contentClasses}>
            {itemCols
                .filter(itemCol => itemCol && itemCol.length)
                .map(itemCol => (
                    <SiteNavDropdownColumn
                        key={itemCol[0].serviceId}
                        items={itemCol}
                        trackingLabelPrefix={trackingLabelPrefix}
                    />
                ))}
            {imageModule}
        </div>
    );
};

SiteNavFullWidthDropdownContentComponent.propTypes = {
    moduleItems: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
    navigationModule: PropTypes.object,
};

export const SiteNavFullWidthDropdownContent = createFragmentContainer(
    SiteNavFullWidthDropdownContentComponent,
    {
        navigationModule: graphql`
            fragment SiteNavFullWidthDropdownContent_navigationModule on NavigationModule {
                imageUrl
                ...SiteNavDropdownImageModule_navigationModule
            }
        `,
    }
);
